import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Typography, Grid, Box, Card, useTheme, Divider, Avatar } from '@material-ui/core';
import { IdeaCss } from '../IdeaCss';
import { ReactComponent as InfraStructureIcon } from '../../../assets/imgs/infrastucture-icon.svg';

export function IdeaBusinessUnitLocal() {
  const theme = useTheme();
  const classes = IdeaCss();
  const { t } = useTranslation();
  const { ideaDetailsFlux } = useSelector(state => state.fluxIdeas);

  return (
    <Grid item xs={12}>
      <Card elevation={0} className={classes.card}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box display="flex" alignItems="center">
              <Avatar className={classes.avatarIcon}>
                <InfraStructureIcon style={{ fill: theme.palette.primary.main }} />
              </Avatar>
              <Typography variant="subtitle1">{t('abrangencia')}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={4}>
              <Grid item xs={4}>
                <Typography variant="subtitle2">{t('unidade_de_negocio')}</Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="subtitle2">{t('local')}</Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="subtitle2">{t('area_de_atuacao')}</Typography>
              </Grid>
            </Grid>
            {ideaDetailsFlux.businessUnitLocal.map((businessUnitLocal, index) => (
              <Grid container spacing={4} key={index} display="flex" alignItems="center">
                <Grid item xs={4}>
                  <Typography variant="body2">{businessUnitLocal?.businessUnit?.name}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2">{businessUnitLocal?.local?.name}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2">{businessUnitLocal?.occupationArea?.name}</Typography>
                </Grid>
                {index !== (ideaDetailsFlux.businessUnitLocal.length - 1) && ( 
                  <Grid item xs={12} style={{ paddingTop: 0 }}>
                    <Divider />
                  </Grid>
                )}
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
}
